module.exports = __webpack_public_path__ + "img/menu_button_playnow_normal.2a52855c.png";